import { unitEconomyCase } from './unit-economy';
import { mandaIntegrationCase } from './manda-integration';
import { starProgramCase } from './star-program';

// Export all case studies
export const caseStudies = [
    unitEconomyCase,
    mandaIntegrationCase,
    starProgramCase
];

// Helper function to get case study by ID
export const getCaseStudyById = (id) => {
    return caseStudies.find(study => study.id === id);
};

// Helper function to get case studies by tag
export const getCaseStudiesByTag = (tag) => {
    return caseStudies.filter(study => study.tags.includes(tag));
};

// Helper function to get case studies by category
export const getCaseStudiesByCategory = (category) => {
    return caseStudies.filter(study => study.category === category);
};

// Helper function to get all unique tags
export const getAllTags = () => {
    const tags = new Set();
    caseStudies.forEach(study => {
        study.tags.forEach(tag => tags.add(tag));
    });
    return Array.from(tags);
};

// Helper function to get all unique categories
export const getAllCategories = () => {
    const categories = new Set();
    caseStudies.forEach(study => {
        categories.add(study.category);
    });
    return Array.from(categories);
};